import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { getUserSession } from 'utils/token';

import { blockRegistrationInWpSiteControl } from './-guards';

export const Route = createFileRoute('/n/_public')({
  beforeLoad: () => {
    // Block registration routes in WP Site Control mode
    blockRegistrationInWpSiteControl();

    const session = getUserSession();

    // If already authenticated, redirect to home
    if (session) {
      throw redirect({
        to: '/n/sites',
        replace: true,
      });
    }
  },
  component: PublicLayout,
});

function PublicLayout() {
  return <Outlet />;
}
